<template>
  <div class="course">
    <app-header :customTitle="title" action="search-course"></app-header>
    <main>
      <b-tabs
        class="tabs-materialize tabs-learn" style="width: 100vw;"
        nav-wrapper-class="px-2"
        fill>
        <b-tab class="tab-course" title="รายละเอียด">
          <course-detail :course="courseDetail"></course-detail>
        </b-tab>
        <b-tab class="tab-learning" title="เข้าเรียน" :active="tab === '1'">
          <course-lectures v-if="lectures.length" :courses="lectures"></course-lectures>
        </b-tab>
        <b-tab class="tab-test" title="แบบทดสอบ" :active="tab === '2'">
          <course-test :course-i-d="courseId" :course-tests="courseDetail.get_course_questions"></course-test>
        </b-tab>
      </b-tabs>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AppHeader from '../../components/Header.component'
  import AppFooter from '../../components/Footer.component'
  import CourseDetail from '../../components/learning/CourseDetail.component'
  import CourseLectures from '../../components/learning/CourseLectures.component'
  import CourseTest from '../../components/learning/CourseTest.component'
  import Services from '../../services'

  export default {
    name: 'course',
    components: {
      AppHeader,
      AppFooter,
      CourseDetail,
      CourseLectures,
      CourseTest
    },

    props: {
      courseId: {
        type: String,
        default: null
      },
      tab: {
        type: String,
        default: null
      }
    },
    data () {
      let data = {
        title: '',
        lectures: []
      }
      return data
    },
    computed: {
      // Map Vuex state.
      ...mapState({
        courseDetail: state => {
          return state.Course.courseDetail
        }
      })
    },
    created () {
      return this.$store.dispatch(`Course/getCourseByCode`, this.courseId)
    },
    mounted () {
      // let self = this
      console.log(this.courseId)
      let self = this
      Services.course.getCourseByCode(this.courseId).then(function (response) {
        self.lectures = response.result.get_course_lectures
        console.log('response')
        console.log(self.lectures)
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/styles";

  main {
    margin-top: $header-height;
  }
</style>



// WEBPACK FOOTER //
// src/pages/learning/Course.page.vue